import { Phone, Mail, Globe, Facebook, Twitter, Linkedin } from "react-feather";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center space-x-2 mb-4">
            <span className="bg-gradient-to-r from-green-500 to-yellow-500 text-black font-bold px-2 py-1 rounded-md">
              CT
            </span>
            <span className="font-semibold text-lg">
              Crutial Touch Art & Crafts
            </span>
          </div>
          <p className="text-sm text-gray-400">
            Custom metal works in Kampala—designed for beauty, built for life.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-green-400 transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-green-400 transition-colors"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-green-400 transition-colors"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className="hover:text-green-400 transition-colors"
              >
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-green-400 transition-colors"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white font-semibold mb-4">Contact Info</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center space-x-2">
              <Phone size={16} />
              <span>
                <a href="tel:+256779706977" className="hover:text-green-400">
                  +256 779 706 977 (WhatsApp)
                </a>
              </span>
            </li>
            <li className="flex items-center space-x-2">
              <Phone size={16} />
              <span>
                <a href="tel:+256701175751" className="hover:text-green-400">
                  +256 701 175 751
                </a>
              </span>
            </li>
            {/* <li className="flex items-center space-x-2">
              <Mail size={16} />
              <span>
                <a
                  href="mailto:info@crutialartworks.com"
                  className="hover:text-green-400"
                >
                  info@crutialartworks.com
                </a>
              </span>
            </li> */}
            <li className="flex items-center space-x-2">
              <Globe size={16} />
              <span>Kito opposite tendo mart</span>
            </li>
          </ul>

          {/* Socials (future integration) */}
          <div className="flex space-x-4 mt-4">
            <a href="#" aria-label="Facebook" className="hover:text-green-400">
              <Facebook size={18} />
            </a>
            <a href="#" aria-label="Twitter" className="hover:text-green-400">
              <Twitter size={18} />
            </a>
            <a href="#" aria-label="LinkedIn" className="hover:text-green-400">
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-4 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Crutial Touch Art & Crafts. All rights
        reserved. | Developed by{" "}
        <a
          href="https://jonathan.ashita.africa"
          target="_blank"
          className="text-green-400 underline"
        >
          Mr. Mwebaze
        </a>
      </div>
    </footer>
  );
}
